export default {
  isLoading: false,
  shouldUpdateDataGrid: false,
  listaSolicitudes: [],
  listaSolicitudesFiltrada: [],
  showHideForm: false,
  isOpenModalBorrador: false,
  isOpenModalContinue: false,
  isOpenModalDelete: false,
  isOpenModalGestionar: false,
  editingDraft: false,
  filtrosSolicitudes: null,
  totalSolicitudes: null,
  selectedTipoSolicitud: {
    Icon: "4", name: "Pendientes de aprobación", column: "estadoSolicitud", value: { text: "ingresado", value: 1 },
  },
  activeStep: 1,
  lastCompletedStep: 1,
  steps: [
    {
      id: 1,
      text: "Información de la solicitud",
      subtext: "Ingresa los datos requeridos para crear una nueva solicitud",
    },
    {
      id: 2,
      text: "Información del trabajador",
      subtext:
        "Debes llenar toda la información del trabajador que se ha accidentado",
    },
    {
      id: 3,
      text: "Datos del accidente",
      text2: "Datos de la enfermedad",
      subtext: "Describa de la forma más detallada los hechos que ocurrieron",
    },
    {
      id: 4,
      text: "Solicitante",
      subtext:
        "Información de la persona que realiza la solicitud de agenda SEL",
    },
    {
      id: 5,
      text: "Datos de la empresa",
      subtext:
        "Información de la empresa que realiza la solicitud de agenda SEL",
    },
    {
      id: 6,
      text: "Enviar denuncia",
      subtext: null,
    },
  ],
  isModified: false,
  dataTrabajador: {},
  disableContinueNewComplaint: false,
  pendingComplaints: [],
  jsonData: {
    Id: null,
    formInfoDenuncia: {},
    formInfoTrabajador: {},
    formDatoSiniestro: {},
    formDatosEmpresa: {},
    formDenunciante: {},
    formDatosEnfermedad: {},
    currentStep: 1,
  },
  modalGestionar: {
    contentId: null,
    tabPosition: 0,
    tabs: [" Información general", "Baterías/Prestaciones", "Trabajadores"],
    subTabContent: false,
    id: null,
  },
  dataSelected: null,
  selectedWorkers: null,
  openModalGestionarSolicitud: false,
  openModalRejectGestionarSolicitud: false,
  isOpenModalEliminarTrabajador: false,
  worker: {},
  dataSelectedShow: null
};
